import 'app/styles/global/global.scss';
import './problem.scss';
import { problemList } from '../config/ProblemsList';
import { useNavigate } from 'react-router';
import { RoutePath } from '../../../config/routes';
import { IStateInfoForAnketa } from '../interfaces/IProblem';

/*
 Компонент выводится на главной странице, при клике на элемент произойдет редирект
 на страницу анкеты, где для шага с выбором тем и проблем подставлятся значения из
 того элемента, на который нажати на предыдущей странице
 */
const Problem = () => {
  const navigate = useNavigate();

  const handleClick = (info: IStateInfoForAnketa | undefined): void => {
    navigate(RoutePath.REACT_ANKETA, {
      state: { actionTab: '2', problemsData: info },
    });
  };

  return (
    <section className="problem">
      <div className="problem__container container">
        <span className="problem__suptitle suptitle">направления</span>
        <h2 className="problem__title section-title-big">
          Уделяем внимание <span>каждой</span> проблеме
        </h2>
        <ul className="problem__list">
          {problemList.map(problem => (
            <li
              key={problem.title}
              className="problem__item"
              onClick={() => handleClick(problem.info)}
            >
              {problem.icon}
              <p>{problem.title}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Problem;
